import { Observable } from "rxjs";
import { NzToUi, UiToNz } from "./core.models";

export function uiToNz<T extends object>(input: T): UiToNz<T>;
export function uiToNz(input: string): string;
export function uiToNz(input: unknown): unknown {
  if (typeof input === "string" && input.startsWith("ui")) {
    return `nz${input.substring(2)}`;
  }

  if (typeof input === "object" && input != null) {
    const entries = Object.entries(input);
    if (!entries.some(([key]) => key.startsWith("ui"))) {
      return input;
    }

    const copy = {};
    for (const [key, value] of entries) {
      copy[uiToNz(key)] = value;
    }
    return copy;
  }

  return input;
}

export function nzToUi<T extends object>(input: T): NzToUi<T>;
export function nzToUi(input: string): string;
export function nzToUi(input: unknown): unknown {
  if (typeof input === "string" && input.startsWith("nz")) {
    return `ui${input.substring(2)}`;
  }

  if (typeof input === "object" && input != null) {
    const entries = Object.entries(input);
    if (!entries.some(([key]) => key.startsWith("nz"))) {
      return input;
    }

    const copy = {};
    for (const [key, value] of entries) {
      copy[nzToUi(key)] = value;
    }
    return copy;
  }

  return input;
}

class ResizeObservable<T> extends Observable<T> {
  constructor(el: HTMLElement, selector: (entry: ResizeObserverEntry) => T) {
    super((subscriber) => {
      const resizeObserver = new ResizeObserver((entries) => {
        const value = selector(entries[0]);
        subscriber.next(value);
      });
      resizeObserver.observe(el);

      return function (): void {
        resizeObserver.unobserve(el);
        resizeObserver.disconnect();
      };
    });
  }
}

export class HeightResizeObservable extends ResizeObservable<number> {
  constructor(el: HTMLElement) {
    super(el, (entry) => entry.borderBoxSize[0].blockSize);
  }
}

export class WidthResizeObservable extends ResizeObservable<number> {
  constructor(el: HTMLElement) {
    super(el, (entry) => entry.borderBoxSize[0].inlineSize);
  }
}
